import { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import SidebarComponent from "./scenes/global/Sidebar";
import Dashboard from "./scenes/dashboard";
import PhoneLogin from "./scenes/login";

import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import OTPPage from "./scenes/otp";
import Companies from "./scenes/companies";
import CompanyForm from "./scenes/companies/form";
import CourseCategories from "./scenes/course-categories";
import ProfessionalSkills from "./scenes/professional-skills";
import SoftSkills from "./scenes/soft-skills";
import CourseForm from "./scenes/courses/form";
import QuizPage from "./scenes/quizzes";
import CompanyTerminologies from "./scenes/companies/terminologies";
import CompanyPromoters from "./scenes/companies/promoters";
import CompanyProducts from "./scenes/companies/products";
import CompanyPolicies from "./scenes/companies/policies";
import CompanyPlans from "./scenes/companies/plans";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Layout component for pages with Sidebar and Topbar
const Layout = ({ children, isSidebar, setIsSidebar }) => (
  <div className="app" style={{ display: "flex", height: "100vh" }}>
    <SidebarComponent
      isSidebar={isSidebar}
      style={{ flexShrink: 0, height: "100vh", overflowY: "auto" }}
    />
    <main
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        height: "100vh",
      }}
    >
      <Topbar setIsSidebar={setIsSidebar} />
      <div style={{ flex: 1, overflowY: "auto" }}>{children}</div>
    </main>
  </div>
);

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);

  // Guard: ensure theme is valid
  if (!theme) return <div>Loading...</div>;

  // Check if user is logged in
  const token = localStorage.getItem("authToken");
  const role = localStorage.getItem("role");
  const isLoggedIn = !!token && !!role;

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ToastContainer position="top-right" autoClose={3000} />
        {isLoggedIn ? (
          <Layout isSidebar={isSidebar} setIsSidebar={setIsSidebar}>
            <Routes>
              <Route path="/dashboard" element={<Dashboard />} />

              {role === "Admin" && (
                <>
                  {/* Companies */}
                  <Route path="/companies" element={<Companies />} />
                  <Route path="/companies/add" element={<CompanyForm />} />
                  <Route path="/companies/edit/:id" element={<CompanyForm />} />
                  <Route
                    path="/companies/:id/terminologies"
                    element={<CompanyTerminologies />}
                  />
                  <Route
                    path="/companies/:id/promoters"
                    element={<CompanyPromoters />}
                  />
                  <Route
                    path="/companies/:id/products"
                    element={<CompanyProducts />}
                  />
                  <Route
                    path="/companies/:id/policies"
                    element={<CompanyPolicies />}
                  />
                  <Route
                    path="/companies/:id/plans"
                    element={<CompanyPlans />}
                  />

                  {/* Courses */}
                  <Route
                    path="/course-categories"
                    element={<CourseCategories />}
                  />
                  <Route
                    path="/professional-skills"
                    element={<ProfessionalSkills />}
                  />
                  <Route path="/soft-skills" element={<SoftSkills />} />
                  <Route
                    path="/professional-skills/add"
                    element={<CourseForm />}
                  />
                  <Route path="/soft-skills/add" element={<CourseForm />} />
                  <Route
                    path="/professional-skills/edit/:id"
                    element={<CourseForm />}
                  />
                  <Route
                    path="/soft-skills/edit/:id"
                    element={<CourseForm />}
                  />

                  {/* Quizzes */}
                  <Route path="/courses/:id/quizzes" element={<QuizPage />} />
                </>
              )}

              {/* Fallback */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </Layout>
        ) : (
          <Routes>
            <Route path="/" element={<PhoneLogin />} />
            <Route path="/otp-verification" element={<OTPPage />} />
            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        )}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
